// src/components/admin/PerformanceManagement.js
import React from 'react';
import AdminPerformanceManagement from './performance/AdminPerformanceManagement';

const PerformanceManagement = () => {
    return <AdminPerformanceManagement />;
};

export default PerformanceManagement;